<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.wellness')" :newButShow="true" @newBut="newBut('add')"></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ blog_title: true , wellness_type: true ,typeText:typeText }" />
        <myTable ref="table" :columns="columns" requestUrl="wellness/list" :showPage="true">
          <template v-slot:head_image="{ data }">
            <div class="imgList">
              <img :src="data.row.head_image" />
            </div>
          </template>
          <template v-slot:health_type="{ data }">
            <div>{{ getType(data.row.health_type) }}</div>
          </template>
          <template v-slot:action="{ data }">
            <Icon class="cursor_p" type="md-create" size="24" color="#1F8FC8" @click="newBut('edit',data.row)" />
            <Icon class="cursor_p" type="ios-mail-outline" size="32" color="#1F8FC8" @click="goFan(data.row)" />
            <!-- <Poptip placement="bottom" confirm :title="$t('confirm_delete')" @on-ok="handleDel(data.row)">
              <Icon class="cursor_p mg-left15" type="md-trash" size="24" color="#7D7C7F" />
            </Poptip>-->
          </template>
        </myTable>
      </div>
    </div>
    <edit v-if="modal" @onOk="onOk" :typeList="typeText" :roleList="list" :type="type" :modal="modal" :itemObj="itemObj" @cancel="cancel"></edit>
    <fanList v-if="fanModal" :modal="fanModal" :itemObj="fanObj" @cancel="fanCancel"></fanList>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
import myTableFilter from "@/components/myTableFilter";
import edit from "./module/wellness_edit";
import fanList from "./module/fanList";
export default {
  name: "baseMtag",
  components: { myTable, pageTitle, myTableFilter, edit, fanList, },
  data () {
    return {
      columns: [
        {
          title: this.$t("Info.code"),
          key: "wellness_id",
          align: "center",
          width: 100,
        },
        {
          title: this.$t("title"),
          minWidth: 200,
          key: "title",
          align: "center",
          tooltip: true,
        },
        {
          title: this.$t("type"),
          minWidth: 200,
          key: "health_type",
          slot: "health_type",
          align: "center",
          tooltip: true,
        },
        {
          title: this.$t("content"),
          minWidth: 200,
          key: "content",
          tooltip: true,
          align: "center"
        },
        {
          title: this.$t("brief"),
          key: "brief",
          align: "center",
          tooltip: true,
          minWidth: 200,
        },
        {
          title: this.$t("img_lnk"),
          slot: "head_image",
          align: "center",
          width: 120,
        },
        // {
        //   title: this.$t("img_lnk"),
        //   key: 'imgList',
        //   width: 350,
        //   align: 'center',
        //   render: (h, params) => {
        //     let _img = params.row.imgList;
        //     // let imgs = [_img]; //组装成 数组
        //     if (_img) {
        //       return h(
        //         'viewer',
        //         {
        //           props: {
        //             images: _img //数组
        //           }
        //         },
        //         _img.map(img => {
        //           //循环显示
        //           return h('img', {
        //             attrs: {
        //               src: img,
        //               style: 'width: 40px;height: 40px;margin: 0 5px;'
        //             }
        //           });
        //         })
        //       );
        //     } else {
        //       return h('span', '');
        //     }
        //   }
        // },
        {
          title: this.$t("isHome"),
          key: "is_home",
          align: "center",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                'true-value': "1",
                'false-value': "0",
                value: params.row.is_home
              },
              on: {
                'on-change': value => {
                  this.setStatus(params.row, value, 1);
                }
              }
            });
          }
        },
        {
          title: this.$t("status"),
          minWidth: 120,
          key: "status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                'true-value': "A2",
                'false-value': "A1",
                value: params.row.status
              },
              on: {
                'on-change': value => {
                  this.setStatus(params.row, value, 2);
                }
              }
            });
          }
        },
        {
          title: this.$t("Info.order"),
          key: "sort_id",
          align: "center",
          width: 180,
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "action",
          width: 180,
        },
      ],
      modal: false,
      fanModal: false,
      itemObj: {},
      fanObj: {},
      type: "add",
      list: [],
      typeText: [],
    };
  },
  created () {
    this.getBeforeList();
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    getBeforeList () {
      this.$base.showLoading;
      this.$request.sendPost("wellness/before-add", {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          this.typeText = data.types
        }
      );
    },
    getType (type) {
      let arr = this.typeText.filter(item => item.key == type);
      return arr[0].value;
    },
    newBut (type, item) {
      this.type = type
      this.itemObj = item
      this.modal = true
    },
    goFan (item) {
      this.fanObj = item;
      this.fanModal = true;
    },
    cancel () {
      this.modal = false;
    },
    fanCancel () {
      this.fanObj = {};
      this.fanModal = false;
    },
    onOk () {
      this.$base.msgSuccess(this.$t("op_ok"));
      this.$refs.table.getLoad();
    },
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    setStatus (row, value, type) {
      if (type == 1) row.is_home = value
      else row.status = value
      this.$base.showLoading();
      this.$request.sendPost(
        'wellness/upd-field',
        { wellness_id: row.wellness_id, status: row.status, is_home: row.is_home },
        (success, data, error) => {
          if (!success) return this.$base.alertErr(error.errmsg);
          this.onOk()
        }
      );
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
  .imgList {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/wellness/wellness.vue